define.alias("shared/components/shared/emoji-textarea", "settings/components/shared/emoji-textarea");